// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"01b9a87f","129":"4982724c","212":"7eb3113a","718":"1f867dd2","719":"d43e7c87","821":"9fe3563c"}[chunkId] + ".chunk.js";
};